/* eslint no-plusplus: 0 */

import { store } from "../../ProviderApp";

const InitializeUtils = function () {
  Communicator.pointTolerance = 0.0001;

  // Accessing redux store to get unit details for estimate

  // Unit types required for length conversion between one type to another
  const uType = [];
  uType[(uType.mm = 0)] = "mm";
  uType[(uType.cm = 1)] = "cm";
  uType[(uType.m = 2)] = "m";
  uType[(uType.inch = 3)] = "inch";
  uType[(uType.feet = 4)] = "foot";
  Communicator.uType = uType;

  // Unit types for measured area Area
  const uAreaType = [];
  uAreaType[(uAreaType.sqmm = 0)] = "mm";
  uAreaType[(uAreaType.sqcm = 1)] = "cm";
  uAreaType[(uAreaType.sqm = 2)] = "m";
  uAreaType[(uAreaType.sqinch = 3)] = "inch";
  uAreaType[(uAreaType.sqfeet = 4)] = "foot";
  uAreaType[(uAreaType.acre = 5)] = "Acre";
  uAreaType[(uAreaType.hectare = 6)] = "hectare";
  Communicator.uAreaType = uAreaType;

  // Unit types for measured area Area
  const uVolumeType = [];
  uVolumeType[(uVolumeType.cubmm = 0)] = "mm";
  uVolumeType[(uVolumeType.cubcm = 1)] = "cm";
  uVolumeType[(uVolumeType.cubm = 2)] = "m";
  uVolumeType[(uVolumeType.cubinch = 3)] = "inch";
  uVolumeType[(uVolumeType.cubfeet = 4)] = "foot";
  Communicator.uVolumeType = uVolumeType;

  Communicator.currentLinearUnit = Communicator.uType.m;
  Communicator.currentAreaUnit = Communicator.uAreaType.sqm;
  Communicator.currentVolumeUnit = Communicator.uVolumeType.cubm;
  Communicator.measureTextPadding = 5;
  Communicator.measureTextColor = new Communicator.Color(0, 0, 0);
  Communicator.measureTextFontSize = 12;
  Communicator.measureTextFontWeight = 0;
  Communicator.measureBoxFillColor = new Communicator.Color(255, 255, 255);
  Communicator.measureBoxFillOpacity = 1.0;
  Communicator.measureBoxBorderRadius = 0;
  Communicator.measureSegmentTextVisiblity = true;
  Communicator.measureSegmentTextBox = true;
  Communicator.measureSegmentTextPadding = 5;
  Communicator.measureSegmentTextColor = new Communicator.Color(0, 0, 0);
  Communicator.measureSegmentTextFontSize = 12;
  Communicator.measureSegmentTextFontWeight = 0;
  Communicator.measureSegmentTextBoxColor = new Communicator.Color(255, 255, 255);
  Communicator.measurementSegmentTextBoxOpacity = 1.0;
  Communicator.measurementSegmentTextBoxRadius = 0;

  function ApplyTextBoxStyling(textBox, padding, txtColor, fontSize, fontWeight, boxColor, boxOpacity, boxRadius) {
    // Text customization
    textBox.setPadding(padding);

    textBox._text?.setFillColor(txtColor);
    textBox._text?.setStrokeColor(txtColor);
    textBox._text?.setFontSize(fontSize);
    textBox._text?.setStrokeWidth(fontWeight);

    // Box customization
    textBox._box?.setFillColor(boxColor);
    textBox._box?.setFillOpacity(boxOpacity);
    textBox._box?.setBorderRadius(boxRadius);
  }

  Communicator.ApplyMeasurementStyling = function (measurement) {
    if (!measurement) return;

    if (measurement._textShape) {
      ApplyTextBoxStyling(
        measurement._textShape,
        Communicator.measureTextPadding,
        Communicator.measureTextColor,
        Communicator.measureTextFontSize,
        Communicator.measureTextFontWeight,
        Communicator.measureBoxFillColor,
        Communicator.measureBoxFillOpacity,
        Communicator.measureBoxBorderRadius,
      );
    }

    measurement._texts?.setFillColor(Communicator.measureSegmentTextColor);
    measurement._texts?.setStrokeColor(Communicator.measureSegmentTextColor);
    measurement._texts?.setFontSize(Communicator.measureSegmentTextFontSize);
    measurement._texts?.setStrokeWidth(Communicator.measureSegmentTextFontWeight);

    if (measurement._textBoxes) {
      ApplyTextBoxStyling(
        measurement._textBoxes,
        Communicator.measureSegmentTextPadding,
        Communicator.measureSegmentTextColor,
        Communicator.measureSegmentTextFontSize,
        Communicator.measureSegmentTextFontWeight,
        Communicator.measureSegmentBoxFillColor,
        Communicator.measureSegmentBoxFillOpacity,
        Communicator.measureSegmentBoxBorderRadius,
      );
    }
  };

  // Get unit multiplier based on unit type
  Communicator.GetuMultiplier = function (unit) {
    switch (unit) {
      case Communicator.uType.mm:
        return 1;
      case Communicator.uType.cm:
        return 10;
      case Communicator.uType.m:
        return 1000;
      case Communicator.uType.inch:
        return 25.4;
      case Communicator.uType.feet:
        return 12 * 25.4;
    }
  };

  Communicator.GetLengthInDisplayUnits = function (linearmm, unit) {
    const unitDetails = getEstimateUnitDetails();
    if (!unitDetails || !unitDetails.linearDisplayUnit) return getLinearMarkupUnitsHelper(linearmm, unit);

    const { factor, selectedSymbol } = unitDetails.linearDisplayUnit;
    return `${(linearmm / factor).toFixed(2).toString()} ${selectedSymbol.name}`;
  };

  Communicator.GetAreaUnitConveredString = function (areamm, unit) {
    const unitDetails = getEstimateUnitDetails();
    if (!unitDetails || !unitDetails.areaDisplayUnit) return getAreaMarkupUnitsHelper(areamm, unit);

    const { factor, selectedSymbol } = unitDetails.areaDisplayUnit;
    return `${(areamm / factor).toFixed(2).toString()} ${selectedSymbol.name}`;
  };

  Communicator.GetVolumeUnitConveredString = function (volummm, unit) {
    const unitDetails = getEstimateUnitDetails();
    if (!unitDetails) return getVolumeMarkupUnitsHelper(volummm, unit);

    const { factor, selectedSymbol } = unitDetails.volumeDisplayUnit;
    return `${(volummm / factor).toFixed(2).toString()} ${selectedSymbol.name}`;
  };

  Communicator.Util.ProjectPointOnPlane = function (point3d, plane) {
    const distance = plane.distanceToPoint(point3d);
    const projDiffVector = plane.normal.copy().scale(distance);
    const projectedPoint = Communicator.Point3.subtract(point3d, projDiffVector);
    return projectedPoint;
  };

  Communicator.Util.isPointInsidePolygon2D = function (p, polygon) {
    let isInside = false;

    if (!p || !polygon || !polygon.length) return false;

    const min = new Communicator.Point2(polygon[0]);
    const max = new Communicator.Point2(polygon[0]);

    for (let i = 0; i < polygon.length; ++i) {
      if (polygon[i].x < min.x) min.x = polygon[i].x;
      if (polygon[i].y < min.y) min.y = polygon[i].y;
      if (polygon[i].x > max.x) max.x = polygon[i].x;
      if (polygon[i].y > max.y) max.y = polygon[i].y;
    }

    if (p.x < min.x || p.x > max.x || p.y < min.y || p.y > max.y) return false;

    let i = 0;
    let j = polygon.length - 1;
    for (i, j; i < polygon.length; j = i++) {
      if (
        polygon[i].y > p.y != polygon[j].y > p.y &&
        p.x < ((polygon[j].x - polygon[i].x) * (p.y - polygon[i].y)) / (polygon[j].y - polygon[i].y) + polygon[i].x
      ) {
        isInside = !isInside;
      }
    }
    return isInside;
  };
  Communicator.Util.ComputeVectorToVectorRotationMatrix = function (p1, p2) {
    const EPSILON = 0.0000001;
    p1.normalize();
    p2.normalize();
    const p3 = Communicator.Point3.cross(p1, p2);

    const dprod = Communicator.Point3.dot(p1, p2);
    const l = p3.length();

    // Construct a perpendicular vector for anti-parallel case
    if (l > -EPSILON && l < EPSILON) {
      if (dprod < 0) {
        if (p1.x < -EPSILON || p1.x > EPSILON) {
          p3.x = p1.y;
          p3.y = -p1.x;
          p3.z = 0;
        } else if (p1.y < -EPSILON || p1.y > EPSILON) {
          p3.x = -p1.y;
          p3.y = p1.x;
          p3.z = 0;
        } else if (p1.z < -EPSILON || p1.z > EPSILON) {
          p3.x = -p1.z;
          p3.z = p1.x;
          p3.y = 0;
        } else {
          return new Communicator.Matrix();
        }
      } else {
        return new Communicator.Matrix();
      }
    }

    let ang = Math.atan2(l, dprod);
    ang *= 180 / Math.PI;

    return Communicator.Matrix.createFromOffAxisRotation(p3, ang);
  };

  Communicator.Util.createCubeMesh = async function (viewer, showFaces, offset, scale) {
    let length;
    if (scale != undefined) length = 0.5 * scale;
    else length = 0.5;

    const meshData = new Communicator.MeshData();
    meshData.setFaceWinding(Communicator.FaceWinding.Clockwise);

    const vertices = [
      // front
      -length,
      length,
      length,
      length,
      length,
      length,
      -length,
      -length,
      length,
      length,
      length,
      length,
      length,
      -length,
      length,
      -length,
      -length,
      length,
      // back
      length,
      length,
      -length,
      -length,
      length,
      -length,
      -length,
      -length,
      -length,
      length,
      length,
      -length,
      -length,
      -length,
      -length,
      length,
      -length,
      -length,
      // top
      -length,
      length,
      -length,
      length,
      length,
      -length,
      length,
      length,
      length,
      -length,
      length,
      -length,
      length,
      length,
      length,
      -length,
      length,
      length,
      // bottom
      -length,
      -length,
      -length,
      length,
      -length,
      length,
      length,
      -length,
      -length,
      -length,
      -length,
      -length,
      -length,
      -length,
      length,
      length,
      -length,
      length,
      // left
      -length,
      length,
      -length,
      -length,
      length,
      length,
      -length,
      -length,
      -length,
      -length,
      length,
      length,
      -length,
      -length,
      length,
      -length,
      -length,
      -length,
      // right
      length,
      length,
      length,
      length,
      length,
      -length,
      length,
      -length,
      -length,
      length,
      length,
      length,
      length,
      -length,
      -length,
      length,
      -length,
      length,
    ];
    if (offset != undefined) {
      for (let i = 0; i < vertices.length; i += 3) {
        vertices[i] += offset.x;
        vertices[i + 1] += offset.y;
        vertices[i + 2] += offset.z;
      }
    }
    const normals = [
      // front
      0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1,
      // back
      0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1,
      // top
      0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0,
      // bottom
      0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0,
      // left
      -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0,
      // right
      1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0,
    ];

    const polylines = [
      [
        -length,
        length,
        length,
        length,
        length,
        length,
        length,
        -length,
        length,
        -length,
        -length,
        length,
        -length,
        length,
        length,
      ],
      [
        length,
        length,
        length,
        length,
        length,
        -length,
        length,
        -length,
        -length,
        length,
        -length,
        length,
        length,
        length,
        length,
      ],
      [
        -length,
        length,
        -length,
        length,
        length,
        -length,
        length,
        -length,
        -length,
        -length,
        -length,
        -length,
        -length,
        length,
        -length,
      ],
      [
        -length,
        length,
        length,
        -length,
        length,
        -length,
        -length,
        -length,
        -length,
        -length,
        -length,
        length,
        -length,
        length,
        length,
      ],
    ];
    if (showFaces) meshData.addFaces(vertices, normals);
    else {
      for (let i = 0; i < polylines.length; i++) meshData.addPolyline(polylines[i]);
    }
    return await viewer.model.createMesh(meshData);
  };

  Communicator.Util.createLineMesh = async function (viewer, start, end) {
    const meshData = new Communicator.MeshData();
    meshData.setFaceWinding(Communicator.FaceWinding.Clockwise);
    meshData.addPolyline([start.x, start.y, start.z, end.x, end.y, end.z]);

    return await viewer.model.createMesh(meshData);
  };

  Communicator.Util.hexToRgb = function (hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? new Communicator.Color(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16))
      : null;
  };
};

function getEstimateUnitDetails() {
  const state = store.getState();
  const { estimateData } = state;

  if (estimateData && estimateData._id) {
    const { linearDisplayUnit, areaDisplayUnit, volumeDisplayUnit, countDisplayUnit } = estimateData;
    return {
      linearDisplayUnit,
      areaDisplayUnit,
      volumeDisplayUnit,
      countDisplayUnit,
    };
  }

  return null;
}

function getLinearMarkupUnitsHelper(linearmm, unit) {
  switch (unit) {
    case Communicator.uType.mm:
      return `${linearmm.toFixed(2).toString()} mm `;
    case Communicator.uType.cm:
      return `${(0.1 * linearmm).toFixed(2).toString()} cm `;
    case Communicator.uType.m:
      return `${(0.001 * linearmm).toFixed(2).toString()} m `;
    case Communicator.uType.inch:
      return `${(0.0393701 * linearmm).toFixed(2).toString()} in `;
    case Communicator.uType.feet:
      return `${(0.00328084 * linearmm).toFixed(2).toString()} ft `;
  }
}

function getAreaMarkupUnitsHelper(areamm, unit) {
  switch (unit) {
    case Communicator.uAreaType.sqmm:
      return `${areamm.toFixed(2).toString()} mm\u00B2 `;
    case Communicator.uAreaType.sqcm:
      return `${(0.01 * areamm).toFixed(2).toString()} cm\u00B2 `;
    case Communicator.uAreaType.sqm:
      return `${(0.000001 * areamm).toFixed(2).toString()} m\u00B2 `;
    case Communicator.uAreaType.sqinch:
      return `${(0.00155 * areamm).toFixed(2).toString()} in\u00B2 `;
    case Communicator.uAreaType.sqfeet:
      return `${(0.00001076 * areamm).toFixed(2).toString()} ft\u00B2 `;
    case Communicator.uAreaType.acre:
      return `${(0.0000000002471 * areamm).toFixed(2).toString()} acres `;
    case Communicator.uAreaType.hectare:
      return `${(0.0000000001 * areamm).toFixed(2).toString()} hectare `;
  }
}

function getVolumeMarkupUnitsHelper(volummm, unit) {
  switch (unit) {
    case Communicator.uAreaType.sqmm:
      return `${volummm.toFixed(2).toString()} mm\u00B3 `;
    case Communicator.uAreaType.sqcm:
      return `${(0.001 * volummm).toFixed(2).toString()} cm\u00B3 `;
    case Communicator.uAreaType.sqm:
      return `${(0.000000001 * volummm).toFixed(2).toString()} m\u00B3 `;
    case Communicator.uAreaType.sqinch:
      return `${(0.0000610237 * volummm).toFixed(2).toString()} in\u00B3 `;
    case Communicator.uAreaType.sqfeet:
      return `${(0.0000000353147 * volummm).toFixed(2).toString()} ft\u00B3 `;
  }
}

export function getAllLeafNodesRecur(node, childs) {
  const c = hwv.model.getNodeChildren(node);
  if (c.length == 0) {
    childs.push(node);
    return;
  }
  c.forEach((i) => getAllLeafNodesRecur(i, childs));
}

export default InitializeUtils;
